/* eslint-disable max-len */
import styled from 'styled-components';
import CircleRingIconDark from '../../assets/images/circle-ring-icon.svg';
import CircleRingIconLight from '../../assets/images/circle-ring-icon-light.svg';

const CircleRingIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${CircleRingIconDark}") no-repeat left center`
      : `url("${CircleRingIconLight}") no-repeat left center`};
  background-size: 24px 24px;
  display: inline-block;
  position: relative;
  width: 24px;
  height: 24px;
`;

export default CircleRingIcon;
